import { MapType } from '../types/types';
export const getMapDisplayMode = (links, threshold) => {
    // Counts the amount of links per step
    const amountOfLinks = links.reduce((prev, { stepId }) => prev.has(stepId)
        ? prev.set(stepId, prev.get(stepId) + 1)
        : prev.set(stepId, 1), new Map());
    // Finds the highest number of links in a single step, within all the steps available.
    const highestAmountOfLinks = Math.max(...amountOfLinks.values());
    if (highestAmountOfLinks <= threshold) {
        return MapType.DEFAULT;
    }
    return MapType.LIMITED_LINKS;
};
